<template>
  <div>
    <p v-if="field.label" for="input" class="text-sm text-argus-forest-600 font-semibold mb-2">
      {{ field.label }}
      <span v-if="field.required" class="text-argus-error">*</span>
    </p>

    <template v-if="field.help_text">
      <p class="text-sm text-argus-forest-600 mb-6">{{ field.help_text }}</p>
    </template>

    <div class="flex flex-col items-center w-full mb-1">
      <label
        v-for="(option, index) in field.options"
        :key="`option-${index}`"
        class="flex w-full mb-4 cursor-pointer"
        :for="`${field.id}-radio-option-${index}`"
      >
        <input
          :name="`${field.id}-radio-group`"
          :id="`${field.id}-radio-option-${index}`"
          type="radio"
          class="mt-0.5 w-4 h-4 checked:bg-argus-brand text-argus-brand mr-2"
          @change="updateValue(option)"
          :value="option.value"
          v-model="value"
        />
        <p class="text-argus-forest-600 w-fit text-sm">
          <span class="font-semibold">{{ option.label ? `${option.label}.` : '' }}</span>
          {{ option.description }}
        </p>
      </label>
    </div>

    <template v-if="field.error">
      <p class="text-argus-error text-sm py-1">{{ errorMessage }}</p>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    field: Object,
  },
  emits: ['update'],
  computed: {
    isValid() {
      if (this.field.required && !this.field.value) {
        return false
      }

      return true
    },
  },
  mounted() {
    this.value = this.field.value
  },
  data() {
    return {
      value: null,
      errorMessage: '',
      touched: false,
    }
  },
  methods: {
    getFieldRef(field) {
      let fieldEl = this.$refs[field.id]
      if (Array.isArray(fieldEl)) {
        fieldEl = this.$refs[field.id][0]
      }
      return fieldEl
    },
    updateFieldValue(field, val) {
      field.value = val
    },
    updateValue() {
      this.touched = true
      this.$emit('update', this.value)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = 'This field is required.'
        }
      } else {
        this.errorMessage = ''
      }
    },
  },
}
</script>
<style scoped>
input[type='radio']:focus {
  outline: none;
  box-shadow: none;
}
</style>
